import React, { ReactNode } from 'react';

import {
  Grid,
  GridItem,
  Heading,
  Paragraph,
  Link,
  Text,
} from '@constellation/core';
import { Accordion } from 'components/tagging';

import { ACCORDION_EVENTS } from '../../constants/analytics.constants';
import getLabel from '../../utils/getLabel';

interface PropsType {
  children?: ReactNode;
}

export default function NeedHelpWrapper({
  children,
}: PropsType): React.JSX.Element {
  return (
    <Grid>
      <GridItem>
        <Heading size="s5">{getLabel('needHelp.title')}</Heading>
      </GridItem>
      <GridItem>
        {children}
        <Accordion
          label={getLabel('needHelp.contactUs.title')}
          eventAction={ACCORDION_EVENTS.CONTACT_US}
          variation="standalone"
          marginBottom="06"
        >
          <Paragraph size="s2" weight="bold" marginBottom="03">
            {getLabel('needHelp.contactUs.label')}
          </Paragraph>
          <Paragraph size="s2" marginBottom="03">
            <Link
              href={`tel:${getLabel('needHelp.contactUs.contactNo')}`}
              weight="bold"
            >
              <Text weight="bold" color="brand">
                {getLabel('needHelp.contactUs.contactNo')}
              </Text>
            </Link>
            {getLabel('needHelp.contactUs.dot')}{' '}
            {getLabel('needHelp.contactUs.contactInfo')}
          </Paragraph>
          <Paragraph size="s2" marginBottom="03">
            {getLabel('needHelp.contactUs.callUsUsing')}{' '}
            <Link href={getLabel('needHelp.contactUs.callUsHelpLink')} external>
              {getLabel('needHelp.contactUs.callUsLabel')}
            </Link>
            {getLabel('needHelp.contactUs.dot')}
          </Paragraph>
          <Paragraph size="s2" marginBottom="none">
            <Link href={getLabel('needHelp.contactUs.signVideoLink')} external>
              {getLabel('needHelp.contactUs.signVideoLabel')}
            </Link>{' '}
            {getLabel('needHelp.contactUs.signVideoInfo')}
          </Paragraph>
        </Accordion>
      </GridItem>
    </Grid>
  );
}
